import React from "react"
import Cabecalho from "../Cabecalho"
import { BannerForm } from "./components/BannerForm"

export function CadastroBannerFornecedor() {
    return (
        <>
            <Cabecalho pagina="Cadastro de Banner" />
            <BannerForm />
        </>
    )
}
